import { AlertTriangle, LoaderCircle } from "lucide-react";

export function LoadingBlock({
  children = "Cargando…",
  className = "",
}) {
  return (
    <div className={`suite-loading-block ${className}`.trim()}>
      <LoaderCircle className="suite-spin" size={18} />
      {children}
    </div>
  );
}

export function FeedbackBanner({
  children,
  tone = "error",
  className = "",
}) {
  return (
    <div
      className={`suite-feedback suite-feedback--${tone} ${className}`.trim()}
      role={tone === "error" ? "alert" : "status"}
    >
      <AlertTriangle size={18} />
      <div>{children}</div>
    </div>
  );
}
